import { Form } from "antd";
import { useEffect } from "react";
import { typeForm } from "../../../../types/forms";
import { requestHrsEquivalency } from "../../../../redux/slices/simulation/simulationAction";

export const useFieldsHrsEquivalency = (dispatch, state = { formCheckState: {} }, type = typeForm.create) => {
    const [form] = Form.useForm();
    const formCheck = {
        ...state.formCheckState,
    };

    const onFinish = (values, updateProject) => {
        dispatch(requestHrsEquivalency(type, values, updateProject));
    };

    useEffect(() => {
        form.setFieldsValue({
            ...formCheck,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.formAreaUser]);

    return { form, onFinish };
};
